import { Link, useLocation } from 'react-router-dom';

const tabs = [
  { to: '/', icon: 'ri-home-5-line', label: '首页' },
  { to: '/category/football', icon: 'ri-layout-grid-line', label: '分类' },
  { to: '/search', icon: 'ri-search-line', label: '搜索' },
  { to: '/about', icon: 'ri-information-line', label: '关于' },
];

export default function MobileTabBar() {
  const location = useLocation();

  const isActive = (to: string) => {
    if (to === '/') return location.pathname === '/';
    return location.pathname.startsWith(to.split('/').slice(0, 2).join('/'));
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background-50 border-t border-background-200">
      <div className="grid grid-cols-4">
        {tabs.map((tab) => {
          const active = isActive(tab.to);
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={`flex flex-col items-center justify-center gap-0.5 py-2.5 transition-colors ${
                active ? 'text-accent-600' : 'text-foreground-500'
              }`}
            >
              <i className={`${tab.icon} w-5 h-5 flex items-center justify-center text-lg`} />
              <span className="text-[11px]">{tab.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}